<template lang="pug">
  .languageCurrencySwitcher.relative.z-10.w-38.h-full(v-if="languages.length > 1")
    .currentLangCurrency.flex.items-center.h-8.w-full.px-2.pe-6.bg-form-item-bg.rounded-lg(v-if="locale", @click="toggleOptions")
      BaseFlagIcon.rounded-full.overflow-hidden.text-base(type="square", :country="getCountry(locale)")
      span.border-primary-text.border-s.ps-2.ms-2.whitespace-nowrap {{ `${currencySymbol} ${currency || ''}` }}
      img.inline-block.w-3.h-3.absolute.end-3(v-if="languages?.length > 1", :class="['md:w-4 md:h-4', { '-rotate-180': options }]", src="~assets/images/common/frame_icon_dropdown_normal.png")
    transition(name="fade")
      .langOptions.absolute.top-7.-z-10.py-2.w-full.flex.justify-center(v-if="options")
        .bg-form-item-bg.w-full.rounded-lg.flex.flex-col
          .overscroll-contain.overflow-auto.grid.grid-cols-3.p-2.pb-0.flex-1.h-0.mb-2.max-h-30(:class="['gap-0.5', {'landscape:max-h-19 landscape:xl:max-h-30': props.from === 'setting'}]")
            button.language-item.rounded-lg.flex.justify-center.items-center.p-2.aspect-square(v-for="language in languages", type="button", :class="[language === locale ? 'font-semibold bg-form-item-bg-disabled' : '']", @click="setLocale(language)", :title="$t(`locales.${language}`)")
              BaseFlagIcon.rounded-full.overflow-hidden.text-2xl(type="square", :country="getCountry(language)")
          .grid.grid-cols-2.py-2.mx-2.border-t.border-placeholder-on-primary(class="gap-0.5")
            button.currency-item.rounded-lg.flex.justify-center.items-center.p-2.text-xs(v-for="currency in currencies", type="button", :class="[currency.site === clientId ? 'font-semibold bg-form-item-bg-disabled' : '']", @click="setCurrency(currency)", :title="currency.name") {{ currency.name }}
</template>

<script setup>
import { useLocale } from '@/composables/core/useLocale'
import { useRuntimeConfig } from 'nuxt/app'
import urlJoin from 'url-join'

const { $SoundControl } = useNuxtApp()

// 使用 useLocale composable 來管理語言切換
const { locale, supportedLocales, changeLocale } = useLocale()
const { urls, currency } = useSite()
const { currency: currencySymbol, clientId } = useRuntimeConfig().public

// 使用 @nuxtjs/i18n 配置的語言列表
const languages = supportedLocales
const currencies = urls.value?.mirror || []
const options = ref(false)
const props = defineProps({
  from: {
    type: String,
    default: 'index',
  },
})

const setLocale = async (lang) => {
  $SoundControl.sound.play('click')
  try {
    await changeLocale(lang)
  } catch (error) {
    console.error('[langSwitcher] Failed to change locale:', error)
  }
}

const getCountry = (locale) => {
  return locale.split('-')[1].toLowerCase()
}

const toggleOptions = () => {
  options.value = !options.value
}

const setCurrency = (currency) => {
  if (currency.site === clientId.value) {
    options.value = false
    return
  }
  try {
    const targetURL = urlJoin(currency.url, `?lang=${locale.value}`)
    window.location.href = targetURL
  } catch (error) {
    console.error('[currencySwitcher] Failed to switch currency:', error)
  } finally {
    options.value = false
  }
}
</script>

